import FormValidator from '../form/form-validator.js'
import url from '../../utils/url.js'
import userFriendlyEr from '../../utils/userFriendlyEr.js'
import {ROOT_DOMAIN} from '../../config/config.js'
import {address} from '../../api/api-endpoints.js'
import permissionMixin from '../../mixins/permission-mixin.js'
import {PERMS} from '../../config/permissions.js'

export default {
  mixins: [permissionMixin],
  props: {
    emitterStream: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      disabledFields: [],
      formFreezed: false,
      tabView: null,
      fields: {},
      addressData: {}
    }
  },
  destroyed () {
    this.cleanEditable()
  },
  mounted () {
    if (this.emitterStream) {
      this.$emitter.emit(this.emitterStream, {
        action: 'mounted',
        ctx: this
      })
    }
  },
  created () {
    if (this.emitterStream) {
      this.$emitter.emit(this.emitterStream, {
        action: 'created',
        ctx: this
      })
    }
    this.formValidator = new FormValidator(this)
    this.setFieldsFromRoute()
    this.setDisabledFieldsFromRoute()
    this.initFieldsAfterLoad()
  },
  title: function () {
    if (this.$route.params && this.itemId) {
      if (this.userCanEdit) {
        return this.$translate('Редактирование записи')
      }
      return this.$translate('Просмотр записи')
    } else {
      return this.$translate('Добавление новой записи')
    }
  },
  computed: {
    formTitle () {
      if (this.fields && this.fields.id) {
        if (this.fields.name) {
          return this.fields.name
        }
        return this.$translate('Редактирование записи')
      }
      return this.$translate('Добавление новой записи')
    },
    isEdit () {
      return !!(this.item && this.item.id)
    },
    // for use in src/app/registry/OperatorAllUpdate.vue
    // with duplicate id route
    itemId () {
      return this.$route.params.id || this.$route.params.objectId || null
    },
    ROOT_DOMAIN () {
      return ROOT_DOMAIN
    },
    item () {
      return this.$store.getters.readUrlEndpoint(this.getItemEndpoint(this.$route))
    },
    userCanDelete () {
      return this.$store.getters.userCan('delete', {route: this.$route})
    },
    userCanEdit () {
      return this.$store.getters.userCan('edit', {route: this.$route})
    }
  },
  methods: {
    isFieldDisabled (fieldName) {
      if (this.disabledFields && this.disabledFields.indexOf(fieldName) > -1) {
        return true
      }
      return false
    },
    setFieldsFromRoute () {
      let route = url.getRoute(this.$route)
      if (route.query.setFields) {
        let fields = JSON.parse(route.query.setFields)
        for (let key in fields) {
          this.$set(this.fields, key, fields[key])
        }
      }
    },
    setDisabledFieldsFromRoute () {
      let route = url.getRoute(this.$route)
      if (route.query.setDisabled) {
        let disabledFields = JSON.parse(route.query.setDisabled)
        this.disabledFields = disabledFields
      }
    },
    /**
     * Async validate, start after sync validate
     * @returns {Promise<number>}
     */
    additionalValidate: async function (hasError = false, errors = {}) {
      return Promise.resolve(1)
    },
    saveAddressData: async function (storageObjName = 'addressData') {
      try {
        console.log(this[storageObjName])
        for (let fName in this[storageObjName]) {
          let {addressIdFieldName, data} = this.addressData[fName]
          let savedAddress = await this.$store.dispatch('createModel', {
            url: address.create(this.fields[addressIdFieldName]),
            data
          })
          this.fields[addressIdFieldName] = savedAddress.data.id
        }
      } catch (e) {
        console.error(e)
        return Promise.reject(new Error('Ошибка сохранения адресов'))
      }
      return Promise.resolve(true)
    },
    /**
     * Execute after validate, before send data to server
     * @returns {Promise<*>}
     */
    beforeSaveForm: async function () {
      try {
        await this.saveAddressData()
        return Promise.resolve(1)
      } catch (e) {
        console.error(e)
        return Promise.reject(e)
      }
    },
    /**
     * Get item from store and put to fields
     */
    initFieldsAfterLoad() {
      if (this.item) {
        this.fields = Object.assign({}, this.fields, this.item)
      }
    },
    /**
     * Return class for tab
     * @param tab
     * @returns {string}
     */
    activeClass (tab) {
      if (tab === this.tabView) {
        return 'active'
      }
      return ''
    },
    freezeForm () {
      this.formFreezed = true
      if (this.$refs.modalForm) {
        this.$refs.modalForm.freezeAll()
      } else if (this.emitterStream) {
        this.$emitter.emit(this.emitterStream, {
          action: 'freezeForm',
          freeze: true
        })
      }
    },
    unFreezeFrom () {
      this.formFreezed = false
      if (this.$refs.modalForm) {
        this.$refs.modalForm.unFreezeAll()
      } else if (this.emitterStream) {
        this.$emitter.emit(this.emitterStream, {
          action: 'freezeForm',
          freeze: false
        })
      }
    },
    /**
     * Convert fields before validate and send
     */
    transformFieldsBeforeSend () {

    },
    checkSendFormPerms () {
      if (this.itemId) {
        return this.userHavePermissionEx(PERMS.EDIT)
      }
      return this.userHavePermissionEx(PERMS.CREATE)
    },
    /**
     * On submit form
     * @returns {boolean}
     */
    sendForm () {
      if (this.checkSendFormPerms() === false) {
        return false
      }
      this.transformFieldsBeforeSend()
      let {hasError, errors} = this.formValidator.validate(this)
      if (!hasError) {
        this.freezeForm()
        this.additionalValidate(hasError, errors).then(validateAsync => {
          this.beforeSaveForm().then(response => {
            this.saveForm()
          }).catch(e => {
            console.error(e)
            this.unFreezeFrom()
            this.showOnError(e)
          })
        }).catch(eAsync => {
          console.warn(eAsync)
          this.unFreezeFrom()
        })
      }
    },
    /**
     * Clean data in store for tables with edited fields
     * after save form
     */
    cleanEditable () {
      let {tmpEndpoints} = this.getEditablesEndpointsAndUrl()
      this.$store.commit('deleteEndpoints', {
        endpoints: tmpEndpoints,
        eager: 10
      })
    },
    /**
     * Return data for tables with edited fields
     * @returns {{postUrl: Array, tmpEndpoints: Array}}
     */
    getEditablesEndpointsAndUrl () {
      return {postUrl: [], tmpEndpoints: []}
    },
    /**
     * Execute after form saved
     * @returns {Promise<*>}
     */
    afterSave: async function (response) {
      let errors = []

      if (errors.length > 0) {
        console.log(errors)
        return Promise.reject(errors.join('<br><br>'))
      }

      return Promise.resolve(1)
    },
    /**
     * Get route after save form
     * @returns {{name: String, params: Object, query: Object}}
     */
    getRedirectParams () {
      let route = url.getRedirectRoute(this.$route)
      if (!this.itemId) {
        if (!route.query) {
          route.query = {}
        }
        route.query.sort = '-id'
      }
      return route
    },
    /**
     * @returns {string}
     */
    getSuccessTitle () {
      return 'Запись сохранена'
    },
    /**
     * Action after save from and all async fucntion
     */
    onSuccess (response, afterSaveResponse) {
      this.showOnSuccess(this.getSuccessTitle())
      this.unFreezeFrom()
      this.onSaveForm()
      setTimeout(() => {
        this.$router.push(this.getRedirectParams())
      }, 0)
    },
    /**
     * prepareFieldsForSend to server
     * @param fields
     * @returns {{}}
     */
    prepareFieldsForSend (fields = {}) {
      return fields
    },
    getSaveFormOptions () {
      return {}
    },
    getStoreAction () {
      return this.itemId ? 'updateModel' : 'createModel'
    },
    emitterFormName () {
      return this.$route.name
    },
    onSaveForm () {
      this.$emitter.emit('form', {
        action: 'onSaveForm',
        name: this.emitterFormName()
      })
    },
    onRemove () {
      this.$emitter.emit('form', {
        action: 'onRemove',
        name: this.emitterFormName()
      })
    },
    onPartialSuccess (e) {
      this.unFreezeFrom()
      this.$e.errorBox(
        'Запись сохранена, но не удалось сохранить все данные в таблицах. ',
        {html: userFriendlyEr.recognize(e)}
      )
      this.onSaveForm()
      setTimeout(() => {
        this.$router.push(this.getRedirectParams())
      }, 0)
    },
    onFormSavedResponse (response) {
      this.$set(this.fields, 'id', this.itemId || response.data.id)
    },
    getAsFormData (fields) {
      return null
    },
    convertToFormData () {
      return false
    },
    saveForm () {
      this.$store.dispatch(this.getStoreAction(), Object.assign({
        url: this.getUpdateOrCreateUrl(),
        endpoint: this.getItemEndpoint(this.$route),
        data: this.prepareFieldsForSend(this.fields),
        formData: this.getAsFormData(this.fields),
        convertToFormData: this.convertToFormData()
      }, this.getSaveFormOptions())).then(r => {
        this.onFormSavedResponse(r)
        this.afterSave(r).then(responseAsync => {
          this.onSuccess(r, responseAsync)
        }).catch(e => {
          this.onPartialSuccess(e)
        })
      }).catch(erResponse => {
        console.error(erResponse)
        this.unFreezeFrom()

        if (erResponse && +erResponse.status === 422) {
          let {notFoundedErrorFieldsText} = this.formValidator.handleServerErrors(erResponse, this)
          if (notFoundedErrorFieldsText) {
            this.$e.errorBox(
              'Некорректно заполнены поля',
              {text: notFoundedErrorFieldsText}
            )
          }
        } else {
          this.showOnError(erResponse)
        }
      })
    },
    showOnSuccess (title = 'Действие успешно завершено') {
      this.$e.successBox(title)
    },
    onSuccessDelete (r) {
      this.showOnSuccess('Запись удалена')
      this.onRemove()
      setTimeout(() => {
        this.$router.push(url.getRedirectRoute(this.$route))
      }, 0)
    },
    checkDeletePerms () {
      return this.userHavePermissionEx(PERMS.DELETE)
    },
    confirmBox (
      msg = 'Удаленную запись нельзя будет восстановить',
      title = 'Удалить запись?',
      btnLabel = 'Удалить'
    ) {
      return this.$e.confirmBox(msg, title, btnLabel)
    },
    showOnError (er) {
      this.$e.errorBox(er)
    },
    deleteItem () {
      if (this.checkDeletePerms() === false) {
        return false
      }
      this.confirmBox().then(() => {
        this.$store.dispatch('deleteModel', {
          url: this.getDeleteUrl(this.fields.id),
          endpoint: this.getItemEndpoint(this.$route)
        }).then(r => {
          this.onSuccessDelete(r)
        }).catch(erResponse => {
          console.error(erResponse)
          this.showOnError(erResponse)
        })
      })
    },
    /**
     * Return server endpoint for update data
     * @returns {string}
     */
    getUpdateOrCreateUrl () {
      return ''
    },
    /**
     * Return server endpoint for remove item
     * @param fieldId
     * @returns {string}
     */
    getDeleteUrl (fieldId) {
      return ''
    },
    /**
     * Return server endpoint for load item data
     * @param route
     * @param fromRoute
     * @returns {string|null}
     */
    getItemEndpoint (route, fromRoute = {}) {
      return null
    }
  },
  /**
   * Execute in global route hook before component created
   * needed for SSR and Data Pre-Fetching
   * https://ssr.vuejs.org/en/data.html
   * @param store
   * @param route
   * @param fromRoute
   * @param methods
   * @returns {Promise<*>}
   */
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
